import { mainPageAnimation } from './main-page.animation';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BackgroundPlayerComponent, DwallClickableMediaDirective } from '@core';
import { InteractionPromptComponent } from '@app/components/interaction-prompt/interaction-prompt.component';
import { TabBarComponent } from '@app/views/tab-bar/tab-bar.component';
import { environment } from '@env/environment';
import { IdleNavigationService } from '@app/services/idle-navigation';
import { BackNavigationService } from '@app/services/back-navigation';

@Component({
  selector: 'app-main',
  templateUrl: './main-page.component.html',
  styleUrl: './main-page.component.scss',
  providers: [IdleNavigationService, BackNavigationService],
  animations: [
    mainPageAnimation,
  ],
  imports: [
    RouterOutlet,
    TabBarComponent,
    BackgroundPlayerComponent,
    DwallClickableMediaDirective,
    InteractionPromptComponent,
  ],
  host: {
    '[style.--ad-player-bg]': 'backgroundAdPlayer',
    '[class.tab-bar-disabled]': '!idleNavigation.tabBarEnabled()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainPageComponent {

  protected readonly idleNavigation = inject(IdleNavigationService);
  public readonly backgroundAdPlayer = environment.backgroundAdPlayerColor ?? '#000000';

  protected onWakeTouch(event: Event): void {
    // Keep the native click for a completed tap; cancelled touches must not navigate.
    event.stopPropagation();
  }

  protected onWakeClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    void this.idleNavigation.openFromHome();
  }
}
